<template>
    <b-input-group :prepend="title">
        <b-input type="text" v-model="model"/>
    </b-input-group>
</template>

<script>
    export default {
        name: "capitalInput",
        props: {
            title: {required: true, default: 'Field'},
        },
        computed: {
            model: {
                get () {
                    return this.value
                },
                set (val) {
                    const value = val ? val.toUpperCase() : null
                     this.$emit('input', value)
                }
            }
        }
    }
</script>

<style scoped>

</style>
